class KubotaExpandingBanner extends HTMLElement {
  connectedCallback() {
    this._waitForGsap(() => this._init());
  }

  disconnectedCallback() {
    this._destroy();
  }

  _waitForGsap(cb, attempts = 0) {
    if (window.gsap && window.ScrollTrigger) {
      window.gsap.registerPlugin(window.ScrollTrigger);
      cb();
      return;
    }
    if (attempts > 40) return;
    setTimeout(() => this._waitForGsap(cb, attempts + 1), 50);
  }

  _init() {
    if (this._mm) return;

    const startPct = parseFloat(this.dataset.startPct || '30');
    const expandPx = parseFloat(this.dataset.expandPx || '300');
    const easePow = parseFloat(this.dataset.ease || '1.8');
    const textRevealAt = parseFloat(this.dataset.textRevealAt || '0.4');
    const imgStartScale = parseFloat(this.dataset.imgStartScale || '0.88');
    const imgEndScale = parseFloat(this.dataset.imgEndScale || '1');
    const viewport = this.querySelector('.kubota-expanding-banner__viewport');
    const content = this.querySelector('.kubota-expanding-banner__content');
    if (!viewport || !content) return;

    const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isReduced || isMobile) {
      content.setAttribute('aria-hidden', 'false');
    }

    const mm = window.ScrollTrigger.matchMedia({
      '(min-width: 750px) and (prefers-reduced-motion: no-preference)': () => {
        const easeInOut = (t) =>
          t < 0.5 ? 0.5 * Math.pow(2 * t, easePow) : 1 - 0.5 * Math.pow(2 * (1 - t), easePow);

        const tl = window.gsap.timeline({
          scrollTrigger: {
            trigger: this,
            start: `top ${100 - startPct}%`,
            end: () => `+=${expandPx}`,
            scrub: 0.3,
            invalidateOnRefresh: true,
            onUpdate: (self) => {
              content.setAttribute('aria-hidden', self.progress >= 0.85 ? 'false' : 'true');
            },
          },
        });

        tl.to(this, { '--ke-progress': 1, ease: easeInOut, duration: 1 }, 0);
        tl.fromTo(
          this,
          { '--ke-img-scale': imgStartScale },
          { '--ke-img-scale': imgEndScale, ease: easeInOut, duration: 1 },
          0
        );
        tl.to(
          this,
          { '--ke-text-progress': 1, ease: 'power2.out', duration: 1 - textRevealAt },
          textRevealAt
        );

        return () => {
          tl.kill();
          window.ScrollTrigger.getAll()
            .filter((s) => s.trigger === this)
            .forEach((s) => s.kill());
          content.setAttribute('aria-hidden', 'false');
        };
      },
    });

    this._mm = mm;
  }

  _destroy() {
    if (this._mm) {
      this._mm.kill?.();
      this._mm = null;
    }
    if (window.ScrollTrigger) {
      window.ScrollTrigger.getAll()
        .filter((s) => s.trigger === this)
        .forEach((s) => s.kill());
    }
  }
}

if (!customElements.get('kubota-expanding-banner')) {
  customElements.define('kubota-expanding-banner', KubotaExpandingBanner);
}

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('kubota-expanding-banner')) {
    window.ScrollTrigger?.refresh();
  }
});
document.addEventListener('shopify:section:unload', (e) => {
  if (e.target.querySelector('kubota-expanding-banner')) {
    window.ScrollTrigger?.refresh();
  }
});
document.addEventListener('shopify:section:reorder', () => {
  window.ScrollTrigger?.refresh();
});
